import React, { Component } from 'react';
import API from '../api.js';
import Tools from '../tools';
import { Container, Row, Col, Form, Button, FormCheck } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setLoginData } from '../actions/actions';
import '../css/login.css';
import Enums from '../enums'

class Register extends Component {

    constructor() {
        super();
        Tools.init();
        API.init(this);

        //TODO: try auto-login if ac, tk exsit in cookie


        // this.login();
        this.state = {
            ac: "",
            pw: "",
            pwChk: "",
            veriCode: "",
            isSendingVeri: false,
            contact: "",
            mobile: "",
            mobileVeriCode: "",
            isSendingMobileVeri: false,
            international_code: "886",
            coName: "",
            coCity: "",
            currentCoAreaAry: [],
            coArea: "",
            coZipCode: "",
            coNumber: "",
            coPhone: "",
            coPhoneExt: "",
            coPhoneDist: "",
            cpDetailAddr: "",
            know_from_where: "",
            agree: "",
            isValid: false,
            invoiceType: 0
        };
        this.onAcChange = this.onAcChange.bind(this);
        this.onPwChange = this.onPwChange.bind(this);
        this.onPwChkChange = this.onPwChkChange.bind(this);
        this.onVeriChange = this.onVeriChange.bind(this);
        this.onContactChange = this.onContactChange.bind(this);
        // this.onMobileChange = this.onMobileChange.bind(this);
        this.onMobileVeriChange = this.onMobileVeriChange.bind(this);
        this.onCONameChange = this.onCONameChange.bind(this);
        this.onInvoiceTypeChange = this.onInvoiceTypeChange.bind(this);

        this.renderForm = this.renderForm.bind(this);

        this.onSendEmailVerification = this.onSendEmailVerification.bind(this);
        this.onSendMobileVerification = this.onSendMobileVerification.bind(this);
        this.onCOCityChange = this.onCOCityChange.bind(this);
        this.onCOAreaChange = this.onCOAreaChange.bind(this);
        this.onCODetailAddrChange = this.onCODetailAddrChange.bind(this);
        this.onKnowFromWhereChange = this.onKnowFromWhereChange.bind(this);
        this.onBack = this.onBack.bind(this);

        // this.onCONumberChange = this.onCONumberChange.bind(this);
        // this.onCOPhoneChange = this.onCOPhoneChange.bind(this);
        // this.onCOPhoneDistChange = this.onCOPhoneDistChange.bind(this);
        // this.onCOPExthoneChange = this.onCOPhoneExtChange.bind(this);
        this.onAgreeChange = this.onAgreeChange.bind(this);

        this.onSubmit = this.onSubmit.bind(this);
        this.onNumberChange = this.onNumberChange.bind(this);
    }

    onSendEmailVerification(e) {
        e.stopPropagation();
        e.preventDefault();
        // console.log(this.state);
        const { ac } = this.state;
        // this.onEndEmailVerification = this.onEndEmailVerification.bind(this);
        this.setState({ isSendingVeri: true });
        API.SendEmailVerification(ac)
            .then(data => {
                console.log(data);
                this.setState({ isSendingVeri: false });

                //401 {"msg":"Email格式錯誤","code":"24004"}
                //200 {"msg":"驗證信已寄出，請至您的電子郵件信箱確認驗證碼","code":"22020"}
                //200 {"msg":"此帳號已註冊","code":"23011"}

                if (!data || !data.code
                    || (22020 != data.code)
                ) {
                    if (data.msg) alert(data.msg);
                    else alert("請確認資料");
                } else {
                    if (data.msg) alert(data.msg);
                    else alert("驗證信已寄出，請至您的電子郵件信箱確認驗證碼");
                }
            }) // JSON from `response.json()` call
            .catch(error => console.error(error))
    }

    onSendMobileVerification(e) {
        e.stopPropagation();
        e.preventDefault();
        // console.log(this.state);
        const { ac, mobile } = this.state;
        // this.onEndEmailVerification = this.onEndEmailVerification.bind(this);
        this.setState({ isSendingMobileVeri: true });

        API.SendPhoneVerification(ac, "886", mobile)
            .then(data => {
                this.setState({ isSendingMobileVeri: false });
                console.log(data);

                //401 {"msg":"Email格式錯誤","code":"24004"}
                //200 {"msg":"簡訊已寄出，請確認驗證碼","code":"22020"}

                if (!data || !data.code
                    || (22020 != data.code)
                ) {
                    if (data.msg) alert(data.msg);
                    else alert("請確認資料");
                } else {
                    if (data.msg) alert(data.msg);
                    else alert("簡訊已寄出，請確認驗證碼");
                }
            }) // JSON from `response.json()` call
            .catch(error => console.error(error))
    }

    onSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        this.setState({ isValid: true });

        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            alert("請確認填寫內容")
            return;
        }
        if (false == this.state.agree) {
            alert("請同意相關條款")
            return;
        }

        e.stopPropagation();
        e.preventDefault();
        // console.log(this.state);
        const header = {
            email: this.state.ac,
            email_verify_code: this.state.veriCode,
            password: this.state.pw,
            password_again: this.state.pwChk,
            contact: this.state.contact,
            international_code: this.state.international_code,
            phone_num: this.state.mobile,
            phone_verify_code: this.state.mobileVeriCode,
            principal: this.state.coName,
            inc_no: this.state.coNumber,
            inc_name: this.state.coName,
            inc_tel_dist: this.state.coPhoneDist,
            inc_tel: this.state.coPhone,
            inc_tel_ext: this.state.coPhoneExt,
            inc_zipcode: this.state.coZipCode,
            inc_city: this.state.coCity,
            inc_dist: this.state.coArea,
            inc_addr: this.state.cpDetailAddr,
            know_from_where: this.state.know_from_where
        };
        this.onAcChange = this.onAcChange.bind(this);

        API.RegisterCustomerAccount(header)
            .then(data => {
                console.log(data, API.first_page);
                //{msg: "內文格式不符 org.json.JSONException: JSONObject["password_again"] not found.", code: "25000"}
                //{msg: "註冊成功:gloria_lin186@hotmail.com", code: "22000"}

                if (data && data.code) {
                    if (data.msg) alert(data.msg);
                    else alert("請確認資料");
                    if (22000 == data.code) {
                        setTimeout(() => {
                            this.props.history.push(API.first_page);
                        }, 100)
                    }
                } else {
                    alert("請確認資料");
                }
            }) // JSON from `response.json()` call
            .catch(error => console.error(error))

        // API.Login(ac, pw
        // 	, function (data) {
        // 		// window.location.href = API.first_page;
        // 		console.log(API.first_page);
        // 		this.props.history.push(API.first_page);
        // 	}.bind(this), function (ac, tk) {
        // 		this.props.setLoginData(ac, tk)
        // 		// alert( $.i18n.get("login-failMsg") );
        // 	}.bind(this));
    }

    onAcChange(e) {
        this.setState({ ac: e.target.value });
    }
    onPwChange(e) {
        this.setState({ pw: e.target.value });
    }
    onPwChkChange(e) {
        this.setState({ pwChk: e.target.value });
    }
    onVeriChange(e) {
        this.setState({ veriCode: e.target.value.toUpperCase() });
    }
    onContactChange(e) {
        this.setState({ contact: e.target.value });
    }
    onMobileChange(e) {
        this.setState({ mobile: e.target.value });
    }
    onMobileVeriChange(e) {
        this.setState({ mobileVeriCode: e.target.value.toUpperCase() });
    }
    onCONameChange(e) {
        this.setState({ coName: e.target.value });
    }
    onInvoiceTypeChange(type){
        this.setState({ invoiceType: type});
    }
    onCOCityChange(e) {
        let tmp = Enums.E_CITY_AREA.hasOwnProperty(e.target.value) ? Enums.E_CITY_AREA[e.target.value] : [];
        this.setState({
            coCity: e.target.value,
            currentCoAreaAry: tmp,
            coArea: "",
            coZipCode: ""
        });
    }
    onCOAreaChange(e) {
        // console.log(Enums.E_AREA_ZIP);
        this.setState({
            coArea: e.target.value,
            coZipCode: Enums.E_AREA_ZIP[e.target.value]
        });
    }
    onCONumberChange(e) {

    }

    onNumberChange(name, e) {
        if (e.target.value.match(/^[0-9]*$/)) {
            let tmp = {};
            tmp[name] = e.target.value;
            this.setState(tmp);
        }
    }

    // onCOPhoneChange(e) {
    //     this.onNumberChange("coPhone", e);
    // }
    // onCOPhoneDistChange(e) {
    //     this.onNumberChange("coPhoneDist", e);
    // }
    onCODetailAddrChange(e) {
        this.setState({ cpDetailAddr: e.target.value });
    }
    onAgreeChange(e) {
        this.setState({ agree: e.target.checked });
    }

    onKnowFromWhereChange(e) {
        this.setState({ know_from_where: e.target.value });
    }
    onBack(e) {
        this.props.history.push('/login');
    }

    renderForm() {
        const { ac, pw, pwChk, veriCode,
            contact,
            mobile,
            mobileVeriCode,
            coName,
            coCity,
            coArea,
            coZipCode,
            currentCoAreaAry,
            cpDetailAddr,
            coNumber,
            coPhone,
            coPhoneExt,
            coPhoneDist,
            agree,
            isValid,
            isSendingVeri,
            isSendingMobileVeri,
            know_from_where,
            invoiceType
        } = this.state;
        const { onAcChange, onPwChange, onPwChkChange, onSubmit,
            onSendEmailVerification,
            onVeriChange,
            onContactChange,
            onMobileChange,
            onMobileVeriChange,
            onCONameChange,
            onInvoiceTypeChange,
            onSendMobileVerification,
            onCOCityChange,
            onCOAreaChange,
            onCODetailAddrChange,
            // onCOPhoneChange,
            onNumberChange,
            // onCOPhoneDistChange,
            onAgreeChange,
            onKnowFromWhereChange,
            onBack
        } = this;

        let cityDom = [];
        cityDom.push(<option value="">縣市</option>)
        Object.keys(Enums.E_CITY_TEXT).forEach(key => {
            cityDom.push(<option value={key}>{Enums.E_CITY_TEXT[key]}</option>)
        })
        let areaDom = [];
        areaDom.push(<option value="">縣市</option>)
        currentCoAreaAry.forEach(key => {
            areaDom.push(<option value={key}>{Enums.E_CITY_AREA_TEXT[key]}</option>)
        })

        return (
            <>
                {/* <Col md={12}>
					<h1 className="text-border-white">EZChoice</h1>
				</Col> */}
                <Form validated={isValid} onSubmit={onSubmit}>
                    <Form.Group as={Row} controlId="formGroupSignup">
                        <Form.Label column sm={3}>帳號*</Form.Label>
                        <Col sm={6}>
                            <Form.Control autoComplete="account" name="hidden" type="email" value={ac} onChange={onAcChange} placeholder="請輸入電子信箱" required />
                        </Col>
                        <Col sm={3}>
                            <Button variant="primary" className="w-100" onClick={onSendEmailVerification}><div className="x-small line-height-1_1">{isSendingVeri ? "發送中.." : (<span>發送<br />驗證碼</span>)}</div></Button>
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="formGroupSignup">
                        <Form.Label column xs={{ offset: 1, span: 10 }} sm={{ span: 3, offset: 3 }}>驗證碼*</Form.Label>
                        <Col xs={{ offset: 1, span: 10 }} sm={{ span: 6, offset: 0 }}>
                            <Form.Control autoComplete="veri_code" name="hidden" type="text" value={veriCode} onChange={onVeriChange} placeholder="" required />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="formGroupPwd">
                        <Form.Label column sm={3}>密碼*</Form.Label>
                        <Col sm={9}>
                            <Form.Control autocomplete="new-password" name="hidden" type="password" value={pw} onChange={onPwChange} placeholder="密碼需使用8~20個英數混合字元" pattern="^[A-Za-z0-9]{8,20}$" required />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="formGroupPwdCheck">
                        <Form.Label column sm={3}>確認密碼*</Form.Label>
                        <Col sm={9}>
                            <Form.Control autocomplete="new-password-veri" name="hidden" type="password" value={pwChk} onChange={onPwChkChange} placeholder="密碼需使用8~20個英數混合字元" pattern="^[A-Za-z0-9]{8,20}$" required />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="formGroupContactCheck">
                        <Form.Label column sm={3}>聯絡人*</Form.Label>
                        <Col sm={9}>
                            <Form.Control autocomplete="name" name="hidden" type="text" value={contact} onChange={onContactChange} placeholder="" required />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="formGroupPwdCheck">
                        <Form.Label column sm={3}>手機*</Form.Label>
                        <Col sm={6}>
                            <Form.Control autocomplete="mobile" name="hidden" type="tel" value={mobile} onChange={(e) => { onNumberChange("mobile", e) }} placeholder="" pattern="[0-9]{10}" required />
                        </Col>
                        <Col sm={3}>
                            <Button variant="primary" className="w-100" onClick={onSendMobileVerification}><div className="x-small line-height-1_1">{isSendingMobileVeri ? "發送中.." : (<span>發送<br />驗證碼</span>)}</div></Button>
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="formGroupSignup">
                        <Form.Label column xs={{ offset: 1, span: 10 }} sm={{ span: 3, offset: 3 }}>驗證碼*</Form.Label>
                        <Col xs={{ offset: 1, span: 10 }} sm={{ span: 6, offset: 0 }}>
                            <Form.Control autoComplete="mobile-veri" name="hidden" type="text" value={mobileVeriCode} onChange={onMobileVeriChange} placeholder="" required />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="formGroupContactCheck" className='mb-3'>
                        <Form.Label column sm={3}>發票開立方式</Form.Label>
                        <Col sm={4}>
                            <Form.Check
                                style={{paddingLeft: "1.25rem", marginTop: "7px"}}
                                inline
                                label="二聯式發票"
                                name="invoice"
                                type="radio"
                                checked={invoiceType==0}
                                value={0}
                                onChange={e=>onInvoiceTypeChange(0)}
                            />
                        </Col>
                        <Col sm={4}>
                            <Form.Check
                                style={{paddingLeft: "1.25rem", marginTop: "7px"}}
                                inline
                                label="三聯式發票"
                                name="invoice"
                                type="radio"
                                checked={invoiceType==1}
                                value={1}
                                onChange={e=>onInvoiceTypeChange(1)}
                            />
                        </Col>
                    </Form.Group>
                    
                    <Form.Group id="inc_name" as={Row} controlId="formGroupContactCheck" style={{display: invoiceType==0?"none":null}}>
                        <Form.Label column sm={3}>公司抬頭*</Form.Label>
                        <Col sm={9}>
                            <Form.Control autocomplete="inc_name" name="hidden" type="text" value={coName} onChange={onCONameChange} placeholder="" required={invoiceType==1}/>
                        </Col>
                    </Form.Group>

                    <Form.Group id="inc_no" as={Row} controlId="formGroupContactCheck" style={{display: invoiceType==0?"none":null}}>
                        <Form.Label column sm={3}>統一編號*</Form.Label>
                        <Col sm={9}>
                            <Form.Control autocomplete="inc_no" name="hidden" type="text" value={coNumber} minLength="8" maxLength="8" onChange={(e) => { onNumberChange("coNumber", e) }} placeholder="" required={invoiceType==1} />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="formGroupContactCheck">
                        <Form.Label column sm={3}>聯絡電話</Form.Label>
                        <Col sm={2}>
                            <Form.Control autocomplete="new-password" name="hidden" type="tel" maxLength="3" value={coPhoneDist} onChange={(e) => { onNumberChange("coPhoneDist", e) }} placeholder="" />
                        </Col>
                        -
                        <Col sm={3}>
                            <Form.Control autocomplete="new-password" name="hidden" type="tel" maxLength="9" value={coPhone} onChange={(e) => { onNumberChange("coPhone", e) }} placeholder="" />
                        </Col>
                        Ext
                        <Col sm={3}>
                            <Form.Control autocomplete="new-password" name="hidden" type="tel" maxLength="10" value={coPhoneExt} onChange={(e) => { onNumberChange("coPhoneExt", e) }} placeholder="" />
                        </Col>
                    </Form.Group>


                    <Form.Group as={Row} controlId="formGroupContactCheck">
                        <Form.Label column sm={3}>聯絡地址</Form.Label>
                        <Col sm={3}>
                            <Form.Control as="select" defaultValue="" value={coCity} onChange={onCOCityChange}>
                                {cityDom}
                            </Form.Control>
                        </Col>
                        <Col sm={3}>
                            <Form.Control as="select" defaultValue="" value={coArea} onChange={onCOAreaChange}>
                                {areaDom}
                            </Form.Control>
                        </Col>
                        <Col sm={3}>
                            <Form.Control autocomplete="new-password" name="hidden" type="text" disabled value={coZipCode} />
                        </Col>
                        <Col sm={12}>
                            <Form.Control autoComplete="new-password" name="hidden" type="text" value={cpDetailAddr} onChange={onCODetailAddrChange} placeholder="" />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="formGroupContactCheck">
                        <Form.Label column sm={3}>從哪得知9EZ!*</Form.Label>
                        <Col sm={9}>
                            <Form.Control autocomplete="know_from_where" name="hidden" type="text" value={know_from_where} onChange={onKnowFromWhereChange} placeholder="" required/>
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="formGroupContactCheck">
                        <Col col={2} className="text-right my-1">
                            <Form.Check style={{ float: "right" }} type="checkbox" checked={agree ? "checked" : ""} onChange={onAgreeChange} isStatic={false} />
                            {/* <input className="" type="checkbox" value="Car" checked={agree ? "checked" : ""} onChange={onAgreeChange} /> */}
                        </Col>
                        <Form.Label column xs={10}>我同意9EZ!<a href="https://www.9ez-dsigroup.com/%E4%BD%BF%E7%94%A8%E6%A2%9D%E6%AC%BE%E8%88%87%E6%A2%9D%E4%BB%B6" target="_blank">會員條款</a>、<a href="https://www.9ez-dsigroup.com/%E9%9A%B1%E7%A7%81%E6%AC%8A%E4%BF%9D%E8%AD%B7%E6%94%BF%E7%AD%96" target="_blank">隱私權聲明</a></Form.Label>
                    </Form.Group>

                    <Form.Group controlId="formGroupBtns">
                        <Col xs={12} className="text-center">
                            <Button className="w-100" variant="primary" type="submit">註冊會員</Button>
                        </Col>
                    </Form.Group>

                    <Form.Group controlId="formGroupBtns">
                        <Col xs={12} className="text-center">
                            <Button className="w-100" variant="link" onClick={onBack}>Back</Button>
                        </Col>
                    </Form.Group>
                </Form>
            </>
        )
    }

    render() {
        const { renderForm } = this;

        return (
            <div id="main-content" className="mt-4">
                <Container className="h-100">
                    <Row className="justify-content-center h-100">
                        <Col className="my-auto col-12 col-md-10 col-lg-8">
                            <h4>註冊帳號</h4>
                            {renderForm()}
                        </Col>
                        {/* <Col className="d-display d-sm-none fixed-bottom mb-2">
							{renderForm()}
						</Col>
						<Col className="d-none d-sm-block my-auto col-6 ">
							{renderForm()}
						</Col> */}
                    </Row>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    ac: state.authReducer.ac,
    tk: state.authReducer.tk
})

const mapDispatchToProps = {
    setLoginData: setLoginData
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Register)
// export default Login;
